/// <reference path="DOMAttached.js" />

class ActiveRatingBar extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		if (this.options.showDescription) {
			this.desc = this.el.querySelector('ul').querySelectorAll('li');
		}

		this.stars = this.el.querySelectorAll('span.star');
		this.rating = this.el.querySelector('.ratingValue');
		this.safeObserve(this.el, 'mouseover', this.onMouseOver.bind(this));
		this.safeObserve(this.el, 'mouseout', this.onMouseOut.bind(this));
		this.safeObserve(this.el, 'click', this.onClick.bind(this));
	}

	onMouseOver(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		var star = ev.target.closest('span');
		if (star == undefined || !star.classList.contains('star')) {
			return;
		}

		this.updateStars(star);
	}

	onMouseOut(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		var _star = ev.target.closest('span');
		if (_star == undefined || !_star.classList.contains('star')) {
			return;
		}

		var rating = this.rating.value;
		var star = null;
		this.stars.forEach(function(el) {
			--rating;
			if (rating == 0) {
				star = el;
			}
		});
		this.updateStars(star);
	}

	updateStars(star) {
		var count = 0;
		var starMode = (star != null) ? 'On' : 'Off';
		this.stars.forEach(function(el) {
			if (starMode == 'On') {
				++count;
				el.style.background = 'url(' + this.options.starOnSrc + ') top left no-repeat';
			} else {
				el.style.background = 'url(' + this.options.starOffSrc + ') top left no-repeat';
			}
			if (star == el) {
				starMode = 'Off';
			}
		});
		if (this.options.showDescription) {
			this.desc.forEach(function(el) {
				--count;
				if (count == -1) {
					if (window.getComputedStyle(el).getPropertyValue("display") == "none") {
						el.style.display = block;
					}
				} else {
					if (window.getComputedStyle(el).getPropertyValue("display") != "none") {
						el.style.display = none;
					}
				}
			});
		}
	}

	onClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		var star = ev.target.closest('span');
		if (star == undefined || !star.classList.contains('star')) {
			return;
		}

		var count;
		for (count = 0; count < this.stars.length; ++count) {
			if (this.stars[count] == star) {
				break;
			}
		}

		this.rating.value = (count + 1);
	}
}
